<div class="tabs-header">
  @for (tab of tabs(); track $index) {
    <a 
      class="tab-item"
      [class.active]="isActive($index)"
      (click)="selectTab($index)"
      [attr.data-ideals]="tab.dataIdeals()"
    >
      {{ tab.label() }}
    </a>
  }
</div>
  
<div class="tabs-content">
  @for (tab of tabs(); track $index) {
    @if (isActive($index)) {
      <ng-container *ngTemplateOutlet="tab.template()"/>
    }
  }
</div>
